"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PortalMeta;

var _immutable = _interopRequireDefault(require("immutable"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var _Constants = require("../Constants");

var _PortalMetaCategoryIds = _interopRequireDefault(require("../enums/PortalMetaCategoryIds"));

var _portalMeta = require("../utils/portalMeta");

var FileManagerPortalDataDefaultState = _immutable.default.Map({
  vidyardTosStatus: _Constants.VidyardTosStatus.NOT_ASKED,
  isVideoPQLBannerDismissed: true,
  importImageCopyrightNotice: null,
  updateRequestStatus: _Constants.RequestStatus.UNINITIALIZED,
  fetchRequestStatus: _Constants.RequestStatus.UNINITIALIZED
});

function PortalMeta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FileManagerPortalDataDefaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      vidyardTosStatus = action.vidyardTosStatus,
      portalDataList = action.portalDataList,
      category = action.category,
      apiValue = action.apiValue;

  switch (type) {
    case ActionTypes.UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED:
    case ActionTypes.UPDATE_PORTAL_META_ATTEMPTED:
      return state.merge({
        updateRequestStatus: _Constants.RequestStatus.PENDING
      });

    case ActionTypes.UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED:
      return state.merge({
        vidyardTosStatus: vidyardTosStatus,
        updateRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case ActionTypes.UPDATE_VIDYARD_TOS_STATUS_FAILED:
    case ActionTypes.UPDATE_PORTAL_META_FAILED:
      return state.merge({
        updateRequestStatus: _Constants.RequestStatus.FAILED
      });

    case ActionTypes.FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED:
      return state.merge({
        vidyardTosStatus: (0, _portalMeta.getVidyardTosStatus)((0, _portalMeta.getVidyardTosMap)(portalDataList)),
        isVideoPQLBannerDismissed: (0, _portalMeta.getIsVideoPQLBannerDismissed)((0, _portalMeta.getVideoPQLMap)(portalDataList)),
        importImageCopyrightNotice: (0, _portalMeta.getImportCopyrightMap)(portalDataList).get('category_value'),
        fetchRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case ActionTypes.UPDATE_PORTAL_META_SUCCEEDED:
      if (category === _PortalMetaCategoryIds.default.IMPORT_IMAGE_COPYRIGHT_NOTICE) {
        state = state.set('importImageCopyrightNotice', apiValue);
      }

      return state.merge({
        updateRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    default:
      return state;
  }
}

module.exports = exports.default;